import React, { PureComponent } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import '../assets/scss/Dialog.scss';
import { Button, Image } from 'antd';

export default class Dialog extends PureComponent {

  constructor (props) {
    super(props);
    
  }

  render () {
    const { closeDialog, prizeDetail } = this.props;
    let isWinner = prizeDetail.isWinner || false;

    if (!isWinner) {
      return (
        <div className="dialog-wrap">
          <div className='dialog-bg'>
            <div className='dialog-bgImg' >
              <Image className='dialog-bgImgWrap' src={require('../assets/img/prize_bg.png')} />
            </div>
            <Button 
              className='dialog-close' 
              shape="circle" 
              icon={<CloseOutlined />} 
              onClick={closeDialog}
            />
            <Image className='prize-topBg-empty' src={require('../assets/img/prize_box.png')} />
            <div className='prize-price'> 谢谢参与 </div>
            <div style={{display:'flex', alignItems:'flex-end', marginTop:'-10px'}} >
              <div className='prize-price-yuan'>很遗憾！未中奖</div>
            </div>
            <div className='prize-tips2'> 哎呀,差一点就中了~ </div>
            <img className='prize-button' src={require('../assets/img/prize_button_none.png')} alt='' onClick={closeDialog} />
            <div className='prize-superDate'> 别气馁,下次再接再厉~ </div>
          </div>
        </div>
      )
    }

    return (
      <div className="dialog-wrap">
        <div className='dialog-bg'>
          <div className='dialog-bgImg' >
            <Image className='dialog-bgImgWrap' src={require('../assets/img/prize_bg.png')} />
          </div>
          <Button 
            className='dialog-close' 
            shape="circle" 
            icon={<CloseOutlined />} 
            onClick={closeDialog}
          />
          <div className='prize-top-tips'>运气不错！恭喜获得</div>
          <div className='prize-title'> { prizeDetail.prizeName || '暂无名称' } </div>
          <img className='prize-tips' src={require('../assets/img/coupon_tips.png')} alt='' />
          <div className='prize-price'> { (prizeDetail.lowLimit === 0 ? '无门槛' : ('实付满' + (prizeDetail.lowLimit || '') + '元减' )) }</div>
          <div style={{display:'flex', alignItems:'flex-end', marginTop:'-10px'}} >
            <div className='prize-price-num'> { prizeDetail.couponPrice }</div>
            <div className='prize-price-yuan'>元</div>
          </div>
          <div className='prize-tips2'>领取后可在“我的-优惠券”查看</div>
          <img className='prize-button' src={require('../assets/img/prize_button.png')} alt='' onClick={closeDialog} />
          <div className='prize-superDate'>券有效期至 { prizeDetail.superDate } </div>
        </div>
      </div>
    )
  }
  
}